import { render } from "./crm-opportunities.vue?vue&type=template&id=f2a68516&scoped=true"
import script from "./crm-opportunities.vue?vue&type=script&lang=js"
export * from "./crm-opportunities.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./crm-opportunities.vue?vue&type=style&index=1&id=f2a68516&scoped=true&lang=css"
import "./crm-opportunities.vue?vue&type=style&index=2&id=f2a68516&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2a68516"]])

export default __exports__